// extracted by mini-css-extract-plugin
export default {"list-item":"f_p","list-item--navitem":"f_q"};